import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelDirectVendor extends Layout {
    labelBulkFuelOptions: Label;
    labelT: Label;
    panelBulkFuelOptions: Panel;
    panelTransactionInformation: Panel;
    sourceFuelDirectVendor: DataSource;
    textboxApDivId: Textbox;
    textboxApGlid: Textbox;
    textboxApVendorId: Textbox;
    textboxApVoucherType: Textbox;
    textboxBulkPrice: Textbox;
    textboxChainCode: Textbox;
    textboxCity: Textbox;
    textboxFuelInterfaceId: Textbox;
    textboxPctDiscPassed: Textbox;
    textboxState: Textbox;
    textboxTruckStopCode: Textbox;
}
